<template>
  <div>
    <b-row class="mb-1">
      <b-col>
        <section>
          <b-button
            v-b-modal.modal-filter-refundReport
            variant="outline-primary"
            class="d-flex text-primary"
          >
            <feather-icon icon="FilterIcon" />Filter
          </b-button>
        </section>
      </b-col>
      <b-col v-if="hasData">
        <b-form-group>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="search"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="hasData" class="d-flex justify-content-end">
        <xlsx-workbook>
          <xlsx-sheet
            v-for="sheet in sheets"
            :key="sheet.name"
            :collection="sheet.data"
            :sheet-name="sheet.name"
          />
          <xlsx-download>
            <b-button variant="primary" class="d-flex">
              <feather-icon icon="DownloadCloudIcon" /> Export
            </b-button>
          </xlsx-download>
        </xlsx-workbook>
      </b-col>
    </b-row>

    <b-tabs content-class="mt-4" align="center">
      <b-tab title="Refund Report" active>
        <b-card title="Refund Report">
          <!-- table -->
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :rtl="direction"
            :search-options="{
              enabled: true,
              externalQuery: searchTerm,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <!-- Column: Name -->
              <span v-if="props.column.field === 'refundFOP'">
                <span>
                  {{
                    paymentOptionId.filter(
                      (f) => f.value == props.row.refundFOP,
                    )[0].text
                  }}
                </span>
              </span>
              <span v-else-if="props.column.field === 'refundAccountNumber'">
                <span>
                  {{
                    props.row.refundAccountNumber
                      ? props.row.refundAccountNumber.replace(
                          /(?<=^\d)\d+(?=\d{4}$)/,
                          "****",
                        )
                      : ""
                  }}
                </span>
              </span>
              <!-- Column: Status -->
              <span v-else-if="props.column.field === 'refundStatus'">
                <span>
                  <b-badge
                    v-if="props.row.refundStatus === 0"
                    pill
                    variant="info"
                    class="text-white"
                  >
                    Not Requested
                  </b-badge>

                  <b-badge
                    v-else-if="props.row.refundStatus === 1"
                    pill
                    variant="warning"
                    class="text-white"
                  >
                    Pending
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.refundStatus === 2"
                    pill
                    variant="light-success"
                    class="text-white"
                  >
                    Submitted
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.refundStatus === 3"
                    pill
                    variant="success"
                    class="text-white"
                  >
                    Approved
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.refundStatus === 4"
                    pill
                    variant="light-info"
                    class="text-white"
                  >
                    Sent
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.refundStatus === 5"
                    pill
                    variant="danger"
                    class="text-white"
                  >
                    Rejected
                  </b-badge>
                  <b-badge
                    v-else-if="props.row.refundStatus === 6"
                    pill
                    variant="primary"
                    class="text-white"
                  >
                    Completed
                  </b-badge>
                  <b-badge v-else pill variant="info">
                    {{ props.row.refundStatus }}
                  </b-badge>
                </span>
              </span>
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['5', '10', '15', '30', '50']"
                    class="mx-1"
                    @input="
                      (value) => props.perPageChanged({ currentPerPage: value })
                    "
                  />
                  <span class="text-nowrap">
                    of {{ props.total }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="
                      (value) => props.pageChanged({ currentPage: value })
                    "
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>

          <b-modal
            id="modal-filter-refundReport"
            title="Filter Refund Report"
            ok-title="Filter"
            ok-only
            size="lg"
            @ok="filterRefundReport"
          >
            <b-form>
              <b-row>
                <b-col cols="4">
                  <b-form-group label="Refund FOP" label-for="payment-option">
                    <b-form-select
                      id="merchantId"
                      v-model="refundedFOP"
                      :options="paymentOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                    label="Refunded Date Rage"
                    label-for="paid-date-range"
                  >
                    <flat-pickr
                      v-model="trxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Approval Type" label-for="approved-by">
                    <b-form-select
                      id="approved-by"
                      v-model="refundType"
                      :options="refundTypes"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
          <!-- loadings -->
          <b-overlay :show="isLoading" no-wrap rounded="sm" />
        </b-card>
      </b-tab>
      <b-tab title="Refund Summary">
        <section>
          <b-row class="pricing-card">
            <b-col
              offset-sm-2
              sm="10"
              md="12"
              offset-lg="2"
              lg="10"
              class="mx-auto"
            >
              <b-row>
                <b-col v-for="sum in refundSummary" :key="sum.name" md="4">
                  <b-card class="popular" align="center">
                    <div class="pricing-badge text-right">
                      <b-badge variant="light-primary" pill>
                        {{ sum.parner }}
                      </b-badge>
                    </div>
                    <h3>Payment Option</h3>
                    <b-card-text>{{
                      paymentOptionId.filter((f) => f.value == sum.refundFOP)[0]
                        .text
                    }}</b-card-text>
                    <hr />
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                        >
                          Total Refund Transactions :
                        </sub>
                        <sub
                          class="pricing-basic-value font-medium-1 font-weight-bolder text-primary"
                          >{{ sum.totalRefundTransactions }}</sub
                        >
                      </div>
                    </div>

                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                          >Total Refund Amount :
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.totalRefundAmount }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                        >
                          Currency :
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.currency }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                        >
                          Total Fees :
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                          >{{ sum.totalFees }}
                        </sub>
                      </div>
                    </div>
                    <div class="annual-plan">
                      <div class="plan-price mt-2">
                        <sub
                          class="pricing-duration text-body font-medium-1 font-weight-bold"
                          >Net Refund Amount :
                        </sub>
                        <sub
                          class="ext-body font-medium-1 font-weight-bold text-primary"
                        >
                          {{ sum.netRefundAmount }}
                        </sub>
                      </div>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </section>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BAvatar,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BButton,
  BModal,
  BForm,
  BTabs,
  BTab,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";
import store from "@/store";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  name: "Users",
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BForm,
    BTabs,
    BTab,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    flatPickr,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      hasData: false,
      refundedFOP: 0,
      trxnDateRange: "",
      trxnStartDate: "",
      trxnEndDate: "",
      rows: [],
      pageLength: 5,
      refundType: 2,
      approval: [
        {
          value: 2,
          text: "All",
        },
        {
          value: 0,
          text: "System",
        },
        {
          value: 1,
          text: "Manual",
        },
      ],
      columns: [
        {
          label: "Refund Initiated Date",
          field: "refundRequestedDate",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Amount",
          field: "orderAmount",
          type: "number",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order Id",
          field: "flyGateOrderId",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Refund Account Number",
          field: "refundAccountNumber",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
          type: "number",
        },
        {
          label: "Refund FOP",
          field: "refundFOP",
        },
        {
          label: "Bank Refund Reference",
          field: "refundReferenceCodeFromBank",
        },
        {
          label: "Refunded Date",
          field: "refundedDate",
        },
        {
          label: "Completed By",
          field: "completedBy",
        },
        {
          label: "Status",
          field: "refundStatus",
        },
      ],
      refundSummary: [],
      statusOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Approved" },
        { value: "3", text: "Canceled" },
      ],
      refundTypes: [
        {
          value: 0,
          text: "System Completed",
        },
        {
          value: 1,
          text: "Manualy Completed",
        },
        {
          value: 2,
          text: "All",
        },
      ],
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],
      paymentOptionId: [],
      searchTerm: "",
      summary: [],
      sheets: [
        { name: "Detail Refund Requests", data: [] },
        { name: "Summary", data: [] },
      ],

      url: "",
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallPaymentOptions();
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
            this.paymentOptionId.push({
              value: item.paymentOptionId,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterRefundReport() {
      this.$store.dispatch("config/getActionPrivilege", "Refund-Report");
      this.isLoading = true;
      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      this.refundType === 0 || this.refundType === 1
        ? (this.url = `/Order/api/V1.0/Report/GetRefundReports?refundedFOP=${this.refundedFOP}&fromRefundedDate=${this.trxnStartDate}&toRefundedDate=${this.trxnEndDate}&refundType=${this.refundType}`)
        : (this.url = `/Order/api/V1.0/Report/GetRefundReports?refundedFOP=${this.refundedFOP}&fromRefundedDate=${this.trxnStartDate}&toRefundedDate=${this.trxnEndDate}`);

      axios
        .get(this.url)
        .then((res) => {
          this.sheets[0].data = [];
          this.rows = res.refundedReports;
          this.refundSummary = res.refundSummary;

          res.refundedReports.map((m) => {
            this.sheets[0].data.push({
              "Refund Requested Date": m.refundRequestedDate,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              Amount: m.orderAmount,
              "Custom Order Code": m.customOrderCode,
              "Order Id": m.flyGateOrderId,
              "Refund Merchant Request Code": m.refundMerchantRequestCode,
              "Refund Reference Code": m.refundReferenceCode,
              "Refund Account Number": m.refundAccountNumber,
              "Ticket Number": m.originalTicketNumber,
              "Refund Document Number": m.refundDocumentNumber,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Refund FOP": this.paymentOptionId.filter(
                (f) => f.value == m.refundFOP,
              )[0].text,
              "Bank Refund Reference": m.refundReferenceCodeFromBank,
              "Refunded Date": m.refundedDate,
              "completed By": m.completedBy,
              Status:
                m.refundStatus == 0
                  ? "Refund Not Requested"
                  : m.refundStatus == 1
                  ? "Refund Pending"
                  : m.refundStatus == 2
                  ? "Refund Submitted"
                  : m.refundStatus == 3
                  ? "Refund Approved"
                  : m.refundStatus == 4
                  ? "Refund Sent"
                  : m.refundStatus == 5
                  ? "Refund Rejected"
                  : m.refundStatus == 6
                  ? "Refund Completed"
                  : null,
            });
          });
          res.refundSummary.map((refund) => {
            this.sheets[1].data.push({
              "Provider Name": refund.parner,
              "Total Refund Transactions": refund.totalRefundTransactions,
              "Total Refund Amount": refund.totalRefundAmount,
              Currency: refund.currency,
              "Total Fees": refund.totalFees,
              "Refund FOP": this.paymentOptionId.filter(
                (f) => f.value == refund.refundFOP,
              )[0].text,
              "Net Refund Amount": refund.netRefundAmount,
            });
          });

          // this.sheets[1].data = res.refundSummary;

          this.hasData = true;
          this.isLoading = false;
        })
        .catch((res) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
